import { root, id } from './decoders';

export const decoders = {
  ...root,
  id,
};
